import { ContentType } from "@redotech/redo-support-conversation-protocol-common/conversation-protocol";
import * as z from "zod";
import { array, literal, object, string } from "zod";
import {
  AutoGeneratedFieldsSchema,
  BaseActionableComponentMessageSchema,
} from "../message-parser-utils";
//TODO: Do we need to remove this?
/**
 * This is the message type for when the ai wants to display a list of
 * products to the customer.
 */
export const ProductDisplayMessageSchema =
  BaseActionableComponentMessageSchema.extend({
    contentType: literal(ContentType.PRODUCT_DISPLAY),
    structuredContent: object({
      productsToDisplay: array(object({ productId: string() })),
    }).optional(),
  });

export const ProductDisplayInfoSchema = object({
  id: string(),
  handle: string(),
  title: string(),
  image: object({ src: string(), alt: string().optional() }).optional(),
  priceRange: object({
    minPrice: object({ amount: string(), currency: string() }),
    maxPrice: object({ amount: string(), currency: string() }),
  }).optional(),
  variants: array(object({ id: string(), title: string() })),
});

export type ProductDisplayInfoType = z.infer<typeof ProductDisplayInfoSchema>;

export const ProductDisplayMessageDbParser = ProductDisplayMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);

export type ProductDisplayMessageType = z.infer<
  typeof ProductDisplayMessageDbParser
>;
